// extracted by mini-css-extract-plugin
export default {"button":"ControlButton_button__6A-ez","active":"ControlButton_active__TE4Zw"};